import * as msgpub from "msgpub";

const regex = new RegExp('[0-9]');

export const CDN_DOMAIN_NAME = "service.msgpub.net";

export function removeNonNumericChar(input: string, setTimeout: any) {
    let result = '';
    for(let i = 0; i < input.length; ++i){
        if (input[i].match(regex)) {
            result += input[i];
        }
    }

    setTimeout(result);
}

export function blurActiveElement() {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }
}

export const USER_OPTION = {
    protocol: window.location.protocol === 'https:' ? msgpub.Protocol.WSS : msgpub.Protocol.WS,
    host: window.location.hostname,
    port: 8083,
    path: "/"
}

export const status_mapper = (status: msgpub.Status) => {
    if (status === msgpub.Status.INVALID) return "INVALID";
    else if (status === msgpub.Status.SUCCESS) return "SUCCESS";
    else if (status === msgpub.Status.NOT_EXIST) return "NOT_EXIST";
    else if (status === msgpub.Status.ALREADY_EXIST) return "ALREADY_EXIST";
    else if (status === msgpub.Status.PERMISSION_DENIED) return "PERMISSION_DENIED";
    else if (status === msgpub.Status.CONNECTION_ERROR) return "CONNECTION_ERROR";
    else if (status === msgpub.Status.NOT_SUBSCRIBED) return "NOT_SUBSCRIBED";
    else if (status === msgpub.Status.ALREADY_SUBSCRIBED) return "ALREADY_SUBSCRIBED";
    else if (status === msgpub.Status.UNAUTHORIZED) return "UNAUTHORIZED";
    else if (status === msgpub.Status.INVALID_DATA) return "INVALID_DATA";
    else if (status === msgpub.Status.FATAL_ERROR) return "FATAL_ERROR";
    else return "";
}

export const apptopicstatus_mapper = (atss: msgpub.AppTopicStatus[]) => {
    atss.forEach((e: msgpub.AppTopicStatus) => {
        // @ts-ignore
        e["status"] = status_mapper(e["status"]);
    });

    return atss;
}
